module.exports = __webpack_public_path__ + "assets/32.jpg?4d5bbf3e52203e7f5f1774e3b7ae71dd";